/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

export default function PageLoadSpinner() {
	return (
		<div
			style={{
				backgroundColor: "#d0d0d040",
				top: 0,
				bottom: 0,
				right: 0,
				left: 0,
				position: "absolute",
			}}
		>
			<i
				style={{ left: "50%", position: "absolute", top: "50%" }}
				className="fas fa-spinner loading-spinner spin-animation"
			/>
		</div>
	);
}
